import { createClient } from 'contentful';

const client = createClient({
  space: 'pmc7hp6q5smt',
  accessToken: 'rc_MOiAYVQmFKB9M6WALIyD2y-kRcdj-rWJojW4Cp0w',
});

export default client;